import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import * as d3 from "d3";

const Donut = (props) => {
  const { data, size } = props;
  const { width, height } = size;

  const donutChartRef = useRef();

  const radius = Math.min(width, height) / 2;

  useEffect(() => {
    const color = [props.brandColor, ...props.colors];

    const svg = d3.select(donutChartRef.current);

    // clear donut before re-render
    svg.selectAll("*").remove();

    const pie = d3
      .pie()
      .sort(null) // Do not sort group by size
      .value((d) => d[1]);
    const data_ready = pie(Object.entries(data));

    const arc = d3
      .arc()
      .innerRadius(radius * 1) // This is the size of the donut hole
      .outerRadius(radius * 0.9);

    svg
      .selectAll("allSlices")
      .data(data_ready)
      .join("path")
      .attr("d", arc)
      .attr("fill", (d, i) => color[i])
      .style("opacity", 0.7);
  }, [data, height, radius, width, props.brandColor, props.colors]);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <g
        ref={donutChartRef}
        transform={`translate(${width / 2},${height / 2})`}
      />
    </svg>
  );
};

Donut.propTypes = {
  data: PropTypes.object,
  brandColor: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  })
};

Donut.defaultProps = {
  data: {},
  brandColor: "#0000FF",
  colors: ["var(--border-color)"],
  size: {
    width: 100,
    height: 100
  }
};

export default Donut;
